import { Box, Stack, Typography } from "@mui/material";
import { useThemePalette } from "common/hooks/theme_palette";
import React from "react";

export default function DetailsList({ data }) {
  const { backgroundGray, textGray, labelColor } = useThemePalette();
  return (
    <Box p="24px">
      <Stack direction="row" gap="8px" alignItems="center" mb="26px">
        {data?.icon && (
          <Stack
            justifyContent="center"
            alignItems="center"
            width="48px"
            height="48px"
            sx={{ borderRadius: "8px", bgcolor: backgroundGray }}
          >
            <Box component="img" src={data?.icon} />
          </Stack>
        )}

        <Typography
          fontSize={{ xs: "18px", sm: "26px" }}
          fontWeight="500"
          fontFamily="Cairo"
          width="100%"
          color={textGray}
        >
          {data?.head}
        </Typography>
      </Stack>
      <Stack direction="row" flexWrap="wrap" gap="30px">
        {data?.details?.map((data, idx) => (
          <Stack
            key={idx}
            gap="12px"
            sx={{
              width: { xs: "100%", sm: data?.width ? data?.width : "45%" },
              mr: { xs: 0, sm: "20px" },
            }}
          >
            <Typography fontSize={{ xs: "13px", sm: "16px" }} fontFamily="Cairo" color={labelColor}>
              {data?.label}
            </Typography>
            <Typography
              fontSize={{ xs: "16px", sm: "20px" }}
              fontFamily="Cairo"
              color={data?.color || textGray}
            >
              {data?.name}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Box>
  );
}
